// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Radio_wrapperComponent__eT9i6","radio":"Radio_radio__R6mKu","checked":"Radio_checked__17IXL"};